export const resolveDailyActivitySWRKey = (userId: string | null | undefined) => userId && ["dailyActivity", userId];
